/* The edit flow's layout constants, in one place. */

/* Edge to edge. Kept as a named constant rather than deleted: the bar, the
   rail row and the body all have to agree on it, and that agreement is the
   whole reason this file exists. */
export const FRAME = "w-full";

/* The rail. Wider than the 288 it started at: "Address & Contact" and
   "Authorized Signatory" were running close to the truncation point, and the
   completion card needs the room to breathe. */
export const RAIL = "w-[300px]";

/* The column the form and the action bar share, inside the working area. */
export const MEASURE =
  "mx-auto w-full px-4 sm:max-w-[min(1360px,100%-8rem)] sm:px-0";

/* The top bar's own inner padding. */
export const BAR = "px-4 sm:px-6";
